import React from 'react';
import { Icon } from './Icon.js';
export const IconMoveObjUpRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,2h-4.51c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h2.7l-3.72,3.72c-.293,.293-.293,.768,0,1.061,.146,.146,.338,.22,.53,.22s.384-.073,.53-.22l3.72-3.72v2.7c0,.414,.336,.75,.75,.75s.75-.336,.75-.75V2.75c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "9", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconMoveObjUpRightFill18.js.map